import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';

import actions from './actions';
export default class AuthStore {
    version = '1.0';
    observed = {
        progress: false,
    };
    
    constructor() {
        makeObservable(this, {
            observed: observable,
        });

        withActions(this, actions);
    }

}

export function useAuthStore () {
    const { store } = useStores();
    return store.authStore;
}
